// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_REVIEW_PAGE_COMPONENT_REVIEWS = "Recenze/hodnocen\u00ed";
export const SEO_TITLE_REVIEW_PAGE_COMPONENT_WHERE_TO_BUY = "Kde koupit";
export const WIKI_WRITE_EXPERIENCE = "Napi\u0161 zku\u0161enost";
